const DEFAULT_ADMIN_PANEL_URL = "https://mh-librattum.sinapsecorp.com.br";

const normalizeBaseUrl = (url: string): string => url.replace(/\/$/, "");

const getWindowOrigin = (): string | undefined => {
  if (typeof window === "undefined" || !window.location?.origin) {
    return undefined;
  }

  return window.location.origin;
};

const mapLocalOrigin = (origin: URL): string | null => {
  const portMap: Record<string, string> = {
    "5173": "5174",
    "3010": "13001",
  };
  const targetPort = portMap[origin.port];
  if (!targetPort) {
    return null;
  }

  origin.port = targetPort;
  return origin.origin;
};

const mapPublicOrigin = (origin: URL): string | null => {
  if (!origin.hostname.startsWith("sdx-")) {
    return null;
  }

  origin.hostname = origin.hostname.replace(/^sdx-/, "mh-");
  return origin.origin;
};

const resolveFromOrigin = (currentOrigin?: string): string | null => {
  if (!currentOrigin) {
    return null;
  }

  try {
    const parsedOrigin = new URL(currentOrigin);

    if (parsedOrigin.hostname === "localhost" || parsedOrigin.hostname === "127.0.0.1") {
      return mapLocalOrigin(parsedOrigin);
    }

    return mapPublicOrigin(parsedOrigin);
  } catch {
    return null;
  }
};

export const getAdminPanelBaseUrl = ({
  configuredUrl = import.meta.env.VITE_ADMIN_PANEL_URL as string | undefined,
  currentOrigin = getWindowOrigin(),
}: {
  configuredUrl?: string;
  currentOrigin?: string;
} = {}): string => {
  if (configuredUrl && configuredUrl.trim().length > 0) {
    return normalizeBaseUrl(configuredUrl);
  }

  return resolveFromOrigin(currentOrigin) ?? DEFAULT_ADMIN_PANEL_URL;
};

